export class StockVisual {
    init() {
        document.querySelectorAll('*[data-role=StockVisual]').forEach(el => {
            this.stock(el);
        });
    }

    stock(el) {
        const { enoughVariantsWithStock, currentStock } = el.dataset;

        if (currentStock > 0) {
            el.classList.add('available');
        }
        else if (Boolean(enoughVariantsWithStock)) {
            el.classList.add('backorder-only');
        }
        else {
            el.classList.add('unavailable');
        }
    }
}